// Singleton Supabase client used by SignIn (post-/v1/auth/login setSession seed),
// magic-link reset, and any RLS-protected reads.
//
// R35/R36 — admin app does NOT wrap a `<SupabaseProvider>` in main.tsx;
// consumers directly `import { supabase } from "@/lib/supabase"` from this
// singleton. detectSessionInUrl: false because magic-link reset uses our
// custom /reset?token=<KV-token> flow, NOT Supabase's #access_token=
// fragment — the SDK should NOT auto-process URL params.

import { createClient } from "@supabase/supabase-js";
import { ENV } from "./env";

export const supabase = createClient(ENV.SUPABASE_URL, ENV.SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
